import { LazyStylesService, type LazyStylesheet } from '@cue/lazy-styles';

export const NAVIGATION_LEAFLET_STYLES: readonly LazyStylesheet[] = [
  { id: 'navigation-leaflet-css', href: 'leaflet-css.css' },
];

export const NAVIGATION_OPENLAYERS_STYLES: readonly LazyStylesheet[] = [
  { id: 'navigation-openlayers-css', href: 'openlayers-css.css' },
];

export function loadNavigationLeafletStyles(lazyStyles: LazyStylesService): Promise<void> {
  return lazyStyles.loadMany(NAVIGATION_LEAFLET_STYLES);
}

export function loadNavigationOpenLayersStyles(lazyStyles: LazyStylesService): Promise<void> {
  return lazyStyles.loadMany(NAVIGATION_OPENLAYERS_STYLES);
}
